import { Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'

interface TableLabelProps {
  name: string
  additionalDescription?: string
}

export const TableLabel = ({ name, additionalDescription }: TableLabelProps) => {
  if (!additionalDescription) {
    return <Text>{name}</Text>
  }

  return (
    <Tooltip label={additionalDescription}>
      <Flex gap={Spacing.S8} alignItems="center">
        <Text>{name}</Text>
        <Icon icon="info" />
      </Flex>
    </Tooltip>
  )
}
